var _circle, _path, _rect, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgManager = function SvgManager(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.701,
    r: 8.5,
    fill: "#0E7873"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.395 5.933H9.75V4.99a.36.36 0 0 0-.355-.359H7.297a.36.36 0 0 0-.355.359v.944h-.646V4.99c0-.554.452-1.01 1-1.01h2.099c.549 0 1 .456 1 1.01v.944Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.778,
    y: 5.868,
    width: 9.444,
    height: 5.037,
    rx: 1,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.722 8.701h7.556v4.722H4.722z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.535a.944.944 0 1 0 0-1.89.944.944 0 0 0 0 1.89Z",
    fill: "#0E7873"
  })));
};
export default SvgManager;